import localforage from 'localforage';
import { isEmpty } from 'lodash';
import { setToken as httpSetToken } from 'apsis-plugin';
import ability from '../ability';
import { userTokenStorageKey, userPermissionsStorageKey } from '../../../config';
import * as services from '../services';

/* eslint-disable import/prefer-default-export */
export default {
  async attemptLogin(payload) {
    const { token, user, client } = await services.postLogin(payload);
    this.setToken(token);
    this.setUser(user);
    this.setClient(client);
    this.setOperadora(user.operadora);
    this.setPrestador(user.prestador);
    this.setPrestadorAdministrativo(user.prestadorAdministrativo);
    this.setDependente(user.dependente);
    this.setBeneficiario(user.beneficiario);
    this.setOuvidoria(user.ouvidoria);
    this.setAuditor(user.auditor);
    this.setAdmin(user.admin);
    this.setPermissions(user.permissions);
    return user; // keep promise chain
  },

  async logout() {
    try {
      services.revokeToken();

      // Remove user token and permissions
      localforage.setItem(userTokenStorageKey, null);
      localforage.setItem(userPermissionsStorageKey, null);
      await Promise.all([
        this.setToken(null),
        this.setUser({}),
        this.setClient(null),
        this.setOperadora(false),
        this.setPrestador(false),
        this.setDependente(false),
        this.setBeneficiario(false),
        this.setAdmin(false),
        this.setPermissions([]),
        this.setUraBean({}),
      ]);
    } catch (error) {
      // Handle the error here
    }
  },

  async setUser(user) {
    this.user = user;
    return user;
  },

  async setClient(client) {
    this.client = client;
    return client;
  },

  async setAdmin(admin) {
    this.admin = admin;
    return admin;
  },

  async setOperadora(operadora) {
    this.operadora = operadora;
    return operadora;
  },

  async setBeneficiario(beneficiario) {
    this.beneficiario = beneficiario;
    return beneficiario;
  },

  async setDependente(dependente) {
    this.dependente = dependente;
    return dependente;
  },

  async setOuvidoria(ouvidoria) {
    this.ouvidoria = ouvidoria;
    return ouvidoria;
  },

  async setAuditor(auditor) {
    this.auditor = auditor;
    return auditor;
  },

  async setPrestador(prestador) {
    this.prestador = prestador;
    return prestador;
  },

  async setPrestadorAdministrativo(prestadorAdministrativo) {
    this.prestadorAdministrativo = prestadorAdministrativo;
    return prestadorAdministrativo;
  },

  async setPermissions(permissions) {
    const permissionsUpdates = [];

    for (const value of Object.values(permissions)) {
      const [subject, action] = value.split(':');

      permissionsUpdates.push({ subject, action });
    }

    await ability.update(permissionsUpdates);

    // this.permissions = permissionsUpdates;

    return permissionsUpdates;
  },

  async setToken(payload) {
    const token = isEmpty(payload) ? null : payload.token || payload;
    this.token = token;

    httpSetToken(token);

    return token;
  },

  async checkUserToken() {
    if (!isEmpty(this.token)) {
      return this.token;
    }

    try {
      const token = await localforage.getItem(userTokenStorageKey);
      if (isEmpty(token)) {
        throw new Error('NO_TOKEN');
      }
      this.setToken(token);
      return await this.loadUser();
    } catch (error) {
      this.setToken('');
      throw new Error('FAIL_IN_LOAD_USER ', error);
    }
  },

  // eslint-disable-next-line consistent-return
  async checkPermissions() {
    if (!isEmpty(this.permissions)) {
      return ability.update(this.permissions);
    }

    try {
      const permissions = await localforage.getItem(userPermissionsStorageKey);
      if (isEmpty(permissions)) {
        throw new Error('NO_PERMISSIONS');
      }
      ability.update(permissions);
      this.permissions = permissions;
    } catch (error) {
      // Handle the error here
    }
  },

  async loadUser() {
    try {
      const response = await services.loadUserData();
      this.setUser(response.user);
      this.setClient(response.client);
      this.setOperadora(response.user.operadora);
      this.setPrestador(response.user.prestador);
      this.setPrestadorAdministrativo(response.user.prestadorAdministrativo);
      this.setDependente(response.user.dependente);
      this.setBeneficiario(response.user.beneficiario);
      this.setOuvidoria(response.user.ouvidoria);
      this.setAuditor(response.user.auditor);
      this.setAdmin(response.user.admin);
      this.setPermissions(response.user.permissions);
      this.setUraBean({});
    } catch (error) {
      this.setToken('');
      throw new Error(`FAIL_IN_LOAD_USER ${error}`);
    }
  },

  async setUraBean(uraBean) {
    this.uraBean = uraBean;
    return uraBean;
  },
};
